import { useMemo } from 'react';

import { type FilterSelectOption, LabeledFilterSelect } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { NamedRef } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

import { institutionLabel } from './namedRefLabel';

const { filters, institutionAdmin } = appStrings.modules.coachingDashboard;

type InScopeInstitutionFilterProps = Readonly<{
  institutions: readonly NamedRef[];
  selectedInstitutionId: number | null;
  onChange: (institutionId: number | null) => void;
}>;

export const InScopeInstitutionFilter = ({
  institutions,
  selectedInstitutionId,
  onChange,
}: InScopeInstitutionFilterProps) => {
  const options = useMemo<FilterSelectOption[]>(
    () =>
      institutions.map((institution) => ({
        value: String(institution.id),
        label: institutionLabel(institution),
      })),
    [institutions],
  );

  if (options.length === 0) return null;

  return (
    <LabeledFilterSelect
      id="dashboard-in-scope-institution-filter"
      label={institutionAdmin.inScopeFilterLabel}
      options={options}
      placeholder={filters.all}
      value={selectedInstitutionId !== null ? String(selectedInstitutionId) : ''}
      onChange={(value) => onChange(value === '' ? null : Number(value))}
    />
  );
};
